import React from 'react'
import './StepHeader.scss'

export const StepHeader = ({ title, copy, imageId, alt }) => {
  return (
    <div>
      <div className="step-intro step-subcopy">
        {title && (
          <h2
            className="step-content__title"
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}
        <div
          className="step-content__intro"
          dangerouslySetInnerHTML={{ __html: copy }}
        />
      </div>
      {imageId && (
        <div className="step-image">
          <img
            src={`${process.env.SITE_ASSET_URL}/${imageId}_2x`}
            alt={alt}
            style={{ width: '100%' }}
          />
        </div>
      )}
    </div>
  )
}

export default StepHeader
